import Upload from './Upload';
export default Upload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-upload/es/index.js
// module id = 1162
// module chunks = 0